import { jsx as _jsx } from "react/jsx-runtime";
import { Trans as I18nextTrans } from "react-i18next";
import { useTranslation } from "react-i18next";
/**
 * Wrapper around react-i18next Trans component that ensures i18n instance is available.
 * Works across package boundaries by explicitly passing i18n via props.
 *
 * This solves the "NO_I18NEXT_INSTANCE" error that occurs when Trans is imported directly
 * in packages that have their own copy of react-i18next (due to module duplication).
 *
 * Usage:
 * ```tsx
 * import { AppTrans } from "@amzn/awsmp-max-translations";
 *
 * <AppTrans i18nKey="promptAgreeToDisclaimer">
 *   <Link onFollow={() => setDisclaimerVisible(true)}>
 *     disclaimer
 *   </Link>
 * </AppTrans>
 * ```
 *
 * The i18nKey prop is typed to only accept valid translation keys from common-messages.ts.
 * Invalid keys will produce TypeScript compilation errors.
 */
export function AppTrans(props) {
    const { i18n } = useTranslation("common");
    // Pass i18n instance from initialized translations package
    // The namespace is already set via useTranslation("common")
    return _jsx(I18nextTrans, { ...props, i18n: i18n });
}
